<template>
   <div style="display: flex; justify-content: center; width: 100%;">
       <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
           <v-alert v-if="validationState" color="darkgrey" style="color:#F44336">{{$t(validationState.message)}}</v-alert>
           <transition name="fade" mode="out-in">
             <MeasureSection v-if="shouldDisplaySectionInstructions" :measuresection="question.measuresection" @next="$emit('instructionsDismissed')"></MeasureSection>
             <StepQuestionLayout v-else-if="layout==='step'" :journeyresponse="journeyResponse" @complete="emitComplete($event)"></StepQuestionLayout>
             <HorizontalQuestionLayout v-else-if="layout==='sidebyside'" :journeyresponse="journeyResponse" @complete="emitComplete($event)"></HorizontalQuestionLayout>
             <VerticalQuestionLayout v-else :journeyresponse="journeyResponse" @complete="emitComplete($event)"></VerticalQuestionLayout>
           </transition>
       </div>
   </div>
</template>

<script>
  import MeasureSection from "./section/MeasureSection";
  import HorizontalQuestionLayout from "./layouts/HorizontalQuestionLayout";
  import VerticalQuestionLayout from "./layouts/VerticalQuestionLayout";
  import StepQuestionLayout from "./layouts/StepQuestionLayout";

  export default {
    name: "QuestionRenderer",
    props:{
      journeyResponse:{type:Object, required:true},
      index : {type:Number, default:0},
      showInstructions : {type:Boolean, default:false}
    },
    components:{
      HorizontalQuestionLayout,
      VerticalQuestionLayout,
      StepQuestionLayout,
      MeasureSection,
    },
    computed:{
      validationState(){
        return this.$store.state.assessment.validationState;
      },
      shouldDisplaySectionInstructions(){
        return this.showInstructions && this.question.measuresection && this.question.measuresection.content && !this.hasDisplayedSectionIntro;
      },
      hasDisplayedSectionIntro(){
        return this.$store.state.assessment.sectionIntrosDisplayed[this.question.measuresection.measuresectionid];
      },
      layout(){
        return this.journeyResponse.questionresponse.question.layout;
      },
      question(){
        return this.journeyResponse.questionresponse.question;
      }
    },
    data(){
      return {

      }
    },
    mounted(){

    },
    methods:{
      emitComplete(data){
        this.$emit('complete',data);
      }
    }
  }
</script>

<style scoped>

</style>
